import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { PortalSetPasswordForm } from '@/components/portal/PortalSetPasswordForm';
import { usePortalVerify } from '@/hooks/portal/usePortalAuth';

export const Route = createFileRoute('/(portal)/portal/verify')({
  validateSearch: (s: Record<string, unknown>): { token?: string } => ({
    token: typeof s.token === 'string' ? s.token : undefined,
  }),
  component: PortalVerifyPage,
});

function PortalVerifyPage() {
  const { token } = Route.useSearch();
  const navigate = useNavigate();
  const verify = usePortalVerify();

  return (
    <PortalSetPasswordForm
      title="Create your password"
      description="Set a password to finish activating your portal account."
      submitLabel="Create account"
      token={token}
      pending={verify.isPending}
      onSubmit={async (password) => {
        await verify.mutateAsync({ token: token!, password });
        await navigate({ to: '/portal' });
      }}
    />
  );
}
